import { render, staticRenderFns } from "./RejectedQA.vue?vue&type=template&id=2d744b88&"
import script from "./RejectedQA.vue?vue&type=script&lang=js&"
export * from "./RejectedQA.vue?vue&type=script&lang=js&"
import style0 from "./RejectedQA.vue?vue&type=style&index=0&id=2d744b88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports